<template>
    <div class="schnellkachelBG" @click.self="$emit('close')">
        <div class="schnellkachelAuswahl">
            <h2>Kachel wählen</h2>

            <div class="scrollContainer">
                <div class="kachelGrid">
                    <div 
                        v-for="kachel in schnellkacheln" 
                        :key="kachel.id"
                        class="kachelCard"
                        @click="selectKachel(kachel)"
                    >
                        <img 
                            :src="`/schnellzugriff/${kachel.imgSrc}`" 
                            :alt="kachel.name"
                            class="kachelImage"
                        />

                        <div class="kachelContent">
                            <h3>{{ kachel.name }}</h3>
                            <p>{{ kachel.beschreibung }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Schnellkacheln } from '@/backend_controller/schnellkacheln';
import Swal from 'sweetalert2';

export default {
    name: 'schnellkachelAuswahl',
    components: {
        
    },
    props:{
        
    },
    data() {
      return{
        schnellkacheln: [],
      }
    },
    methods:{
        async getSchnellkacheln(){
            let response = await Schnellkacheln.get();

            if(response == false){
                Swal.fire({
                    icon: 'error',
                    title: 'Fehler',
                    text: 'Schnellkacheln konnten nicht geladen werden.',
                });
                return [];
            } else {
                return response;
            }
        },

        selectKachel(kachel){
            this.$emit('select', kachel);
            this.$emit('close');
            // optional:
            // this.$router.push({ name: kachel.navigation });
        }
    },
    async created() {
        this.schnellkacheln = await this.getSchnellkacheln();
        console.log(this.schnellkacheln);
    },
}
</script>

<style lang="scss" scoped>
.schnellkachelBG{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(4px);

    display: flex;
    justify-content: center;
    align-items: center;

    .schnellkachelAuswahl{
        width: 85vw;
        max-width: 1100px;
        height: 75vh;
        background-color: white;
        border-radius: 12px;
        padding: 25px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.2);

        h2{
            margin-bottom: 20px;
            text-align: center;
        }

        .scrollContainer{
            overflow-y: auto;
            height: calc(100% - 60px);
        }

        .kachelGrid{
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            gap: 20px;
            padding: 10px;
        }

        .kachelCard{
            background: #f8f9fa;
            border-radius: 12px;
            padding: 15px;
            cursor: pointer;
            transition: all 0.25s ease;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            &:hover{
                transform: translateY(-6px);
                box-shadow: 0 8px 20px rgba(0,0,0,0.15);
                background: #ffffff;
            }

            .kachelImage{
                width: 80px;
                height: 80px;
                object-fit: contain;
                margin-bottom: 15px;
            }

            h3{
                margin: 5px 0;
                font-size: 18px;
            }

            p{
                font-size: 14px;
                color: #666;
            }
        }
    }
}
</style>